import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, IconButton, useMediaQuery } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { gradient } from "./utils";

export default function BackButton({ fallbackUrl }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:900px)");

  // Determine a sensible default fallback based on current route
  const computeDefaultFallback = () => {
    const segments = location.pathname.split("/").filter(Boolean);
    if (segments.length > 1) {
      // return first segment as root (e.g., '/audio/123' -> '/audio')
      return `/${segments[0]}`;
    }
    return "/";
  };

  const navBack = () => {
    const hasInternalReferrer = (() => {
      try {
        if (!document.referrer) return false;
        const refOrigin = new URL(document.referrer).origin;
        return refOrigin === window.location.origin;
      } catch {
        return false;
      }
    })();

    if (hasInternalReferrer) {
      navigate(-1);
    } else {
      const target = fallbackUrl || computeDefaultFallback();
      navigate(target, { replace: true });
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        m: 0,
        p: 0,
      }}
    >
      <IconButton
        onClick={navBack}
        sx={{
          width: isMobile ? "3.5rem" : "5rem",
          height: isMobile ? "3.5rem" : "5rem",
          background: "linear-gradient(-45deg, #44A08D, #093637)",
          backgroundSize: "400% 400%",
          animation: `${gradient} 10s ease infinite`,
          m: 0,
          p: 0,
        }}
      >
        <ArrowBack />
      </IconButton>
    </Box>
  );
}
